const generateTreatmentTypeUri = (generateUri, treatmentTypeId) =>
  generateUri('treatmentType', { treatmentTypeId });

const transform = (treatmentTypes, generateUri, i18n) =>
  treatmentTypes.map((treatmentType) => {
    const id = treatmentType.id;
    const title = treatmentType.name;
    const description = i18n(`page.treatment-type.${id}.hero.description`);
    const image = treatmentType.image || {};
    const imageUri = Object.values(image.uris || {})[0];
    const uri = generateTreatmentTypeUri(generateUri, id);

    return {
      title,
      description,
      uri,
      imageUri,
    };
  }, treatmentTypes);

export default transform;
